export default __webpack_public_path__ + "static/media/brochetas.6bda233d.jpg";